import type { ComparisonValue } from '@epilot/journey-logic-commons/src/types/next'
import { LOGIC_OPERATOR } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { Operator } from '../operator'

const FactValueSchema = z.union([
  z.string().transform(Number),
  z.number().finite()
])

/**
 * TODO: unit test
 */
export class LessThanOrEqual extends Operator<string | number> {
  constructor() {
    super(LOGIC_OPERATOR.LESS_THAN_OR_EQUAL, FactValueSchema)
  }

  evaluate(factValue: number, comparisonValue: ComparisonValue): boolean {
    const _comparisonValue = FactValueSchema.parse(comparisonValue)

    if (Number.isNaN(factValue) || Number.isNaN(comparisonValue)) return false

    return factValue <= _comparisonValue
  }
}
